import { proxyModel } from './proxy-model'

export function proxyActivity (activity, proxyFromModelsHash = {}, options = {}) {
  activity = proxyModel(activity, options)
  const proxy = activity.__proxy__
  const flashOptionsProxy = activity._flashOptions && activity._flashOptions.__proxy__

  // Return early since there's already a proxy
  if (proxy && flashOptionsProxy) return activity

  if (activity._flashOptions) {
    proxyModel(activity._flashOptions, options)
  }

  for (const key in proxyFromModelsHash) {
    Object.keys(proxyFromModelsHash[key].attributesMap).forEach((attr) => {
      proxy.set(proxyFromModelsHash[key].attributesMap[attr], proxyFromModelsHash[key].model.get(attr))

      proxy.listenTo(proxyFromModelsHash[key].model, `change:${attr}`, (model, value) => {
        proxy.set(proxyFromModelsHash[key].attributesMap[attr], value)
      })
    })
  }

  return activity
}
